import { render, staticRenderFns } from "./sortOrderSetting.vue?vue&type=template&id=4f5a56ac&scoped=true"
import script from "./sortOrderSetting.vue?vue&type=script&lang=js"
export * from "./sortOrderSetting.vue?vue&type=script&lang=js"
import style0 from "./sortOrderSetting.vue?vue&type=style&index=0&id=4f5a56ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a56ac",
  null
  
)

export default component.exports